// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'waldmeister-prod',
  version: 'Error: no tags found (local or remote).',
  production: false,
  bucketName: 'waldmeister',
  databaseUrl: { supabase: 'https://gzdbydbkfsvaxzuarkca.supabase.co', middleware: '' },
  posCloud: {
    apiURL: 'https://waldmeister.menucat.de/api',
  },
  editEnabled: 'true',
  defaultLanguage: 'DE',
  databaseAnonKey: { supabase: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd6ZGJ5ZGJrZnN2YXh6dWFya2NhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc2ODUzODAsImV4cCI6MjEwMzI2MTM4MH0.29xiCwFnJEBm6uXvn6grJx1E4-P0mYr-W8FlrnsjD6Y', middleware: '' },
  sentryDSN: 'https://05633cd1f0860c686372fe15b2c59c6e@o4510801241440256.ingest.de.sentry.io/4511976975892560',
  posthogKey: 'phc_m3dOImc0jDJ5IzfKERikqSr4Nshq8XFVWV6DJKgYzhu',
  posthogHost: 'https://eu.i.posthog.com',
  posthogProxyHost: 'https://t.unauorder.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
